import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import classNames from "classnames";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { usePrismicCartSliderQuery } from "@temp/@prismic/templates/PrismicCartSlider/hooks/usePrismicCartSlider";
import arrowImg from "../../../images/cart-arrow.svg";
export function CartUpsale() {
  var _data$cartslider;

  var intl = useIntl();

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      activeSlide = _useState2[0],
      setActiveSlide = _useState2[1];

  function goNext() {
    if (activeSlide + 1 >= items.length) {
      setActiveSlide(0);
    } else {
      setActiveSlide(activeSlide + 1);
    }
  }

  function goPrev() {
    if (activeSlide <= 0) {
      setActiveSlide(items.length - 1);
    } else {
      setActiveSlide(activeSlide - 1);
    }
  }

  var _usePrismicCartSlider = usePrismicCartSliderQuery(),
      data = _usePrismicCartSlider.data;

  var items = (data === null || data === void 0 ? void 0 : (_data$cartslider = data.cartslider) === null || _data$cartslider === void 0 ? void 0 : _data$cartslider.body[0].fields.map(function (z) {
    return {
      img: z.image,
      title: z.title,
      url: z.link
    };
  })) || [];
  return React.createElement("div", {
    className: "cart__upsale"
  }, React.createElement("div", {
    className: "cart__upsale-subtitle"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Complete your shopping",
    "id": "components.OverlayManager.Cart.CartUpsale.694902101"
  }, "id", "components.OverlayManager.Cart.CartUpsale.694902101"))), React.createElement("ul", {
    className: "cart__upsale__list"
  }, items.map(function (item, index) {
    var _item$img, _item$img2;

    return React.createElement("li", {
      key: index,
      className: classNames("cart__upsale__list-item", {
        active: activeSlide === index
      })
    }, React.createElement("a", {
      href: item.url,
      className: "cart__upsale__list-link"
    }, React.createElement("div", {
      className: "cart__upsale__list-img"
    }, React.createElement("img", {
      src: (_item$img = item.img) === null || _item$img === void 0 ? void 0 : _item$img.url,
      alt: ((_item$img2 = item.img) === null || _item$img2 === void 0 ? void 0 : _item$img2.alt) || ""
    })), React.createElement("div", {
      className: "cart__upsale__list-title"
    }, item.title)));
  })), React.createElement("div", {
    className: "cart__upsale__controls"
  }, React.createElement("button", {
    className: classNames("cart__upsale__controls-btn prev", {
      disabled: activeSlide === 0
    }),
    type: "button",
    onClick: goPrev
  }, React.createElement("img", {
    src: arrowImg,
    alt: "<"
  })), React.createElement("button", {
    className: classNames("cart__upsale__controls-btn next", {
      disabled: activeSlide + 1 === items.length
    }),
    type: "button",
    onClick: goNext
  }, React.createElement("img", {
    src: arrowImg,
    alt: ">"
  }))));
}